import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const sendPromptBatchToBrightdata = unaryRpc({
  name: "sendPromptBatchToBrightdata",
  input: z.object({
    teamId: zExt.objectId(),
    categories: z.array(z.string()).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    promptCount: z.number(),
    error: z.string().optional(),
  }),
});
